import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { CountryService } from 'src/app/services/country.service';
import { catchError, concatMap, tap } from 'rxjs/operators';
import { ResponseObject } from 'src/app/models/response-object.model';
import { CompanyService } from 'src/app/services/company.service';
import { CountryResponseV2 } from 'src/app/models/country.model';
import { CompanyActivityNameResponse, CompanyContactRequest, CompanyPhoneRequest, CompanyRequest, CompanyScheduleRequest } from 'src/app/models/company.model';
import { HttpErrorResponse } from '@angular/common/http';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { concat, EMPTY } from 'rxjs';
declare let $: any;


@Component({
  selector: 'app-company-request',
  templateUrl: './company-request.component.html',
  styleUrls: ['./company-request.component.scss']
})
export class CompanyRequestComponent {
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  input = {
    value: null,
    verified: false,
    required: false,
    message: '',
    class: '',
    color: '',
    bgColor: 'info',
    data: null,
    filterElements: []
  }
  @Output() close = new EventEmitter<any>();
  step = "0";
  countries: CountryResponseV2[] = [];
  activities: CompanyActivityNameResponse[] = [];
  @Input() newCompany: CompanyRequest = new CompanyRequest();
  country = undefined;
  department = undefined;
  departments = [];
  towns = [];
  newContact: CompanyContactRequest = new CompanyContactRequest();
  newPhone: CompanyPhoneRequest = new CompanyPhoneRequest();
  schedules: CompanyScheduleRequest[] = [];
  days = [false, false, false, false, false, false, false];
  dpi = null;
  opening = null;
  closing = null;
  collectionActivities: { [key: number]: CompanyActivityNameResponse } = {};
  messageNIT = "";

  constructor(
    private countryService: CountryService,
    private toastService: ToastrService,
    private companyService: CompanyService,
    private invoiceSaleService: InvoiceSaleService,
  ) {
    for (let i = 0; i < 7; i++) {
      var temp = new CompanyScheduleRequest();
      temp.day = i;
      this.schedules.push(temp);
    }
  }

  getDisabledForSum() {
    var sum = 0;
    this.days.forEach((day) => {
      sum += (day) ? 1 : 0;
    })
    return sum == 0;
  }

  pushSchedules() {
    for (let i = 0; i < 7; i++) {
      if (this.days[i]) {
        this.schedules[i].closing = this.closing;
        this.schedules[i].opening = this.opening;
        this.days[i] = false;
      }
    }
  }

  write() {
    this.input.filterElements = this.activities.filter((activity) => {
      return activity.code == this.input.value || activity.name.toLowerCase().includes(this.input.value.toLowerCase())
        || activity.id == this.input.value
    });

  }

  select(activitySelected) {
    var find = this.newCompany.activities.find((activity) => {
      return activity == activitySelected.id;
    })
    if (!find) {
      this.newCompany.activities.push(activitySelected.id);
      this.input.value = "";
      this.input.filterElements = this.activities;
    } else {
      this.toastService.info("Ya se encuentra ingresada la actividad");
    }
  }

  pushContact() {
    this.newCompany.contacts.push(Object.assign(this.newContact, {}));
    this.newContact = new CompanyContactRequest();
  }

  clean(toClean: number) {
    for (let i = 0; i < 7; i++) {
      if (i == toClean || toClean == -1) {
        this.schedules[i].closing = null;
        this.schedules[i].opening = null;
      }
    }
  }

  ngOnInit(): void {
    this.getStartData();
  }

  uploadLogo() {
    $('#img').click();
  }

  uploadDPI() {
    $('#dpi').click();
  }

  changedFile(event, isLogo = true) {
    const file: File = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        if (isLogo) {
          this.newCompany.logo = e.target.result;
        } else {
          this.dpi = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    }
  }

  getDisabledGeneral() {
    if (!this.newCompany.name
      || !this.newCompany.nit
      || !this.newCompany.address
      || !this.newCompany.mail
      || !this.newCompany.town
    )
      return true;
  }


  getStartData() {
    this.countryService.getCountry().pipe(
      concatMap((response: ResponseObject) => {
        this.countries = response.data;
        return this.companyService.getActivities();
      })
    ).subscribe(
      {
        next: (response: ResponseObject) => {
          this.activities = response.data;
          this.activities.forEach((ac) => {
            this.collectionActivities[ac.id] = ac;
          });
          console.log(this.collectionActivities);
          this.input.filterElements = this.activities;
        },
        error: __ => {
          this.toastService.error("Error al obtener datos");
        }
      }
    );
  }

  getDepartments() {
    this.department = undefined;
    this.newCompany.town = undefined;
    this.countryService.getDepartmentsByCountry(this.country).subscribe({
      next: (response: ResponseObject) => {
        this.departments = response.data;
      },
      error: __ => {
        this.toastService.error("Error al obtener los departamentos");
      }
    })
  }

  getTowns() {
    this.newCompany.town = undefined;
    this.countryService.getTownsByDepartment(this.department, this.country).subscribe({
      next: (response: ResponseObject) => {
        this.towns = response.data;
      },
      error: __ => {
        this.toastService.error("Error al obtener los departamentos");
      }
    })
  }

  addPhone() {
    this.newCompany.phones.push(this.newPhone);
    var area = this.newPhone.area;
    this.newPhone = new CompanyPhoneRequest();
    this.newPhone.area = area;
  }

  checkNIT() {
    this.companyService.checkNIT(this.newCompany.nit).subscribe({
      next: (response: ResponseObject) => {
        this.messageNIT = "";
        this.newCompany.name = response.data;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.messageNIT = error.error.message;
        // this.toastService.error(error.error.message);
      }
    })

    this.invoiceSaleService.getClientsByNit(this.newCompany.nit).subscribe(
      (response: any) => {
        console.log(response);
        if(response.data && response.data.name){
          this.newCompany.name = response.data.name;
        }

      }, (error) => {
        console.log("Fail to get filter warehouses, " + error);
      });
  }

  onAdministrativeToggle(): void {
    if (this.newCompany.administrative) {
      this.newCompany.nit = '496540k';
    } else {
      this.newCompany.nit = '';
    }
  }

}
